import { ProfessionalActionTypes } from "./actionTypes";

const initialState = {
    professionalListError: null,
    message: null,
    loadingProfessionals: false,
    // Add query parameters to the state to act as a single source of truth.
    query: {
        page: 1, 
        pageSize: 20,
        type: ''
    }
}

const account = (state = initialState, action) => {
    switch (action.type) {
        case ProfessionalActionTypes.PROFESSIONAL_LIST_GET:
            state = {
                ...state,
                professionalList: null,
                professionalListError: null,
                loadingProfessionals: true
            }
            break;
        case ProfessionalActionTypes.PROFESSIONAL_LIST_GET_SUCCESSFUL:
            state = {
                ...state,
                professionalList: action.payload,
                professionalListError: null,
                loadingProfessionals: false
            }
            break;
        case ProfessionalActionTypes.PROFESSIONAL_LIST_GET_ERROR:
            state = {
                ...state,
                professionalList: null,
                professionalListError: action.payload,
                loadingProfessionals: false
            }
            break;
        // Handle updating the stored query.
        case ProfessionalActionTypes.SET_PROFESSIONAL_QUERY:
            state = {
                ...state,
                query: { ...state.query, ...action.payload }
            }
            break;
        case ProfessionalActionTypes.RESET_PROFESSIONAL_QUERY:
            state = {
                ...state,
                query: initialState.query
            }
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default account;
